import React from 'react';
import { Upload } from 'antd';
import { UploadProps as UploadCopyProps } from 'antd/lib/upload';

export type UploadProps = UploadCopyProps;

const ProUpload: React.FC<UploadProps> = React.forwardRef<any, UploadProps>(
  (props, ref) => {
    const { children, ...resProps } = props;

    return (
      <Upload ref={ref} {...resProps}>
        {children}
      </Upload>
    );

  },
);

export default ProUpload;
